import React, { useRef, useState } from "react";
import "../styles.css";
//internal and external componentscontainers
import {
  Typography,
  Paper,
  Box,
  Fade,
  Popper,
  ClickAwayListener,
  Button,
  ThemeProvider,
  createTheme,
  IconButton,
  Tooltip,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight, faPlus } from "@fortawesome/free-solid-svg-icons";
import Textarea from "@mui/joy/Textarea";
import { CssVarsProvider as JoyCssVarsProvider } from "@mui/joy/styles";
import ActionsTable from "../../../components/ActionsTable";
import { AvatarAndName } from "../../../components/AvatarAndName";
import {
  getEvaluationCriteriaStandards,
  getStandardsEvidences,
  getStandardsSelfAssessmentComment,
  getStandrdsActions,
} from "../../../api/evaluation";
import { useDispatch, useSelector } from "react-redux";
import {
  setActionsList,
  setProjectList,
  setSaActions,
  setSaComments,
  setSaEvidences,
  setSaStandards,
  setSelectedSaStandard,
  setStaffList,
  setStandardStatuses,
} from "../../../redux/reducers/evaluation";
import { getAllActions, updateActions } from "../../../api/action";
import { getStaff } from "../../../api/user";
import { getProjectsByClub } from "../../../api/club";
import { evidenceToStandard, uploadFile } from "../../../api/evidence";
import { formatDateTime, genUID } from "../../../common/StaticExports";
import EvidencesTable from "../../../components/EvidencesTable";
import SplitButton from "../../../components/SplitButton";
import EvidencePopup from "../../../components/EvidencePopup";
import { baseUrl } from "../../../api/config";
import { useTranslation } from "react-i18next";
import { SwitchButton } from "../../../components/SwitchButton";
import {
  getStandardIsComplete,
  saveStandardIsComplete,
} from "../../../api/standards";
import { colors } from "../../../common/pallette/colors";
import { setSnackBarData } from "../../../redux/reducers/common";
import { Navigators } from "../../../components/Navigators";

const theme = createTheme({
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          marginLeft: "auto",
          marginRight: "auto",
          marginTop: 50,
        },
      },
    },
  },
});

const SAStandardsDetail = (props: any) => {
  const { detail, isOpen, handleClose } = props;
  const currentClub = useSelector((state: any) => state.clubDetails);
  const [addAction, setAddAction] = React.useState(false);
  const [addEvidence, setAddEvidence] = React.useState(false);
  const [isOpenLibModal, setIsOpenLibModal] = React.useState(false);
  const actions = useSelector((state: any) => state.evaluation.saActions);
  const evidences = useSelector((state: any) => state.evaluation.saEvidences);
  const selfAssessmentComment = useSelector(
    (state: any) => state.evaluation.saComments
  );
  const [isLoadingActions, setIsLoadingActions] = useState(false);
  const [isLoadingEvidences, setIsLoadingEvidences] = useState(false);
  const [isAddAcionLoad, setIsAddAcionLoad] = useState(false);
  const isAdmin = useSelector((state: any) => state.common.isAdmin);
  const currentCriteria = useSelector(
    (state: any) => state.evaluation.selectedSaCriteria
  );
  const standardStatuses = useSelector(
    (state: any) => state.evaluation.standardStatuses
  );
  const isClubMaker = useSelector((state: any) => state.common.isClubMaker);
  const isClubChecker = useSelector((state: any) => state.common.isClubChecker);
  const dispatch = useDispatch();
  const fileInputRef: any = useRef(null);
  const [isEdited, setIsEdited] = useState(false);
  const [t] = useTranslation();
  const standardIds = useSelector((state:any) => state.evaluation.saStandards?.map((standard:any) => standard.id));
  const standards = useSelector((state:any) => state.evaluation.saStandards);

  const tableHead = [
    {
      key: "",
      displayName: "",
    },
    {
      key: "status",
      displayName: "status",
    },
    {
      key: "actionComment",
      displayName: "action",
    },
    {
      key: "description",
      displayName: "description",
    },
    {
      key: "dueDate",
      displayName: "due date",
    },
    {
      key: "owner",
      displayName: "owner",
    },
    {
      key: "",
      displayName: "",
    },
  ];

  React.useEffect(() => {
    if (isOpen && detail?.id && currentClub?.id) {
      const fetchActions = async () => {
        setIsLoadingActions(true);
        const response = await getStandrdsActions({
          standardId: detail?.id,
          clubId: currentClub?.id,
        });
        return response;
      };

      const fetchEvidences = async () => {
        setIsLoadingEvidences(true);
        const response = await getStandardsEvidences({
          standardId: detail?.id,
          clubId: currentClub?.id,
        });
        return response;
      };

      const fetchSelfAssessmentComments = async () => {
        const response = await getStandardsSelfAssessmentComment({
          standardId: detail?.id,
          clubId: currentClub?.id,
        });
        return response;
      };

      const fetchStatuses = async () => {
        const response = await getStandardIsComplete({
          standardId: detail?.id,
          clubId: currentClub?.id,
        });
        return response;
      };

      fetchActions().then((res) => {
        dispatch(setSaActions(res));
        setIsLoadingActions(false);
      });
      fetchEvidences().then((res) => {
        dispatch(setSaEvidences(res));
        setIsLoadingEvidences(false);
      });
      fetchSelfAssessmentComments().then((res) => {
        dispatch(setSaComments(res));
      });
      fetchStatuses().then((res) => {
        dispatch(setStandardStatuses(res));
      });
    }
  }, [isOpen, detail, currentClub]);

  const manageAddAction = () => {
    const fetchActionList = async () => {
      setIsAddAcionLoad(true);
      const response = await getAllActions({
        clubId: currentClub?.id,
        isSelfAssessment: true,
      });
      return response;
    };
    const fetchStaffList = async () => {
      const response = await getStaff({ clubId: currentClub?.id });
      return response;
    };
    const fetchClubProject = async () => {
      const response = await getProjectsByClub({ clubId: currentClub?.id });
      return response;
    };

    if (currentClub?.id) {
      fetchActionList().then((res) => {
        dispatch(setActionsList(res));
      });
      fetchStaffList().then((res) => {
        dispatch(setStaffList(res));
      });
      fetchClubProject().then((res) => {
        dispatch(setProjectList(res));
        setIsAddAcionLoad(false);
      });
    }
    setAddAction(true);
  };

  const handleFileChange = (e: any) => {
    const params: any = {
      clubId: currentClub?.id,
      standardId: detail?.id,
      file: e.target.files[0],
      standardKind: 0,
      currentFolderId: 0,
    };

    const fileUpload = async () => {
      const response = await uploadFile(params);
      return response;
    };

    e.target.files[0] &&
      currentClub?.id &&
      detail?.id &&
      fileUpload().then((res) => {
        const tempArr: any = [...evidences, res];
        dispatch(setSaEvidences(tempArr));
        setAddEvidence(false);
      const warningData: any = {
        isOpen: true,
        severity: "success",
        message: t("EVIDENCE_LINKED_SUCCESSFULLY"),
      };
      dispatch(setSnackBarData(warningData));
      });
  };

  const manageEvidenceClick = (label: any) => {
    switch (label) {
      case "Add Evidence":
        fileInputRef.current.click();
        setAddEvidence(true);
        break;
      case "Add Evidence From Library":
        setAddEvidence(true);
        setIsOpenLibModal(true);
        break;
    }
  };

  const linkLibraryFile = (fileData: any) => {
    const linkToStandard = async () => {
      const response = await evidenceToStandard({
        fileId: fileData.id,
        standardId: detail?.id,
      });
      return response;
    };
    linkToStandard().then((res) => {
      const tempArr: any = [...evidences, res];
      dispatch(setSaEvidences(tempArr));
      setAddEvidence(false);
      setIsOpenLibModal(false);
    });
  };

  const handleAddActionClick = (isAdded: any) => {
    if (isAdded) {
      getEvaluationCriteriaStandards({
        clubId: currentClub?.id,
        criteriaId: currentCriteria.id,
      }).then((response: any) => {
        dispatch(setSaStandards(response));
      });
    }
    setAddAction(false);
  };

  const handleClickInsidePopper = (event: MouseEvent) => {
    event.stopPropagation();
    // handleIsOpen()
  };

  const manageCRUDMethod = async (type: string, dataToUpdate?: any) => {
    switch (type) {
      // CRUD for criteria evaluation actions
      case "create":
        var actionArr: any = [dataToUpdate, ...actions];
        dispatch(setSaActions(actionArr));
        setAddAction(false);
        var parameters = {
          clubId: currentClub?.id,
          standardId: detail?.id,
          actions: actionArr,
        };
        await updateActions(parameters).then((res: any) => {
          dispatch(setSaActions(res));
          const warningData: any = {
            isOpen: true,
            severity: "success",
            message: t("ACTION_CREATED_SUCCESSFULLY"),
          };
          dispatch(setSnackBarData(warningData));
          getEvaluationCriteriaStandards({
            clubId: currentClub?.id,
            criteriaId: currentCriteria.id,
          }).then((response: any) => {
            dispatch(setSaStandards(response));
          });
        });
        break;

      case `delete`:
        var tempArrDelete = actions.filter(
          (actionItem: any) => actionItem.id !== dataToUpdate
        );
        dispatch(setSaActions(tempArrDelete));
        break;

      case `archive`:
        var tempArrArchive = actions.filter(
          (actionItem: any) => actionItem.id !== dataToUpdate
        );
        dispatch(setSaActions(tempArrArchive));
        break;

      case `update`:
        var tempArrUpdate = actions.map((actionItem: any) =>
          actionItem.id == dataToUpdate?.id ? dataToUpdate : actionItem
        );
        dispatch(setSaActions(tempArrUpdate));
        break;

      case `unlink`:
        var tempArrUnlink = actions.filter(
          (actionItem: any) => actionItem.id !== dataToUpdate
        );
        dispatch(setSaActions(tempArrUnlink));
        break;
    }
  };

  React.useEffect(() => {
    if (addEvidence) {
      const warningData: any = {
        isOpen: true,
        message: t("EVIDENCE_UPLOADING_IN_PROGRESS"),
        isLoading: true,
      };
      setTimeout(() => {
        dispatch(setSnackBarData(warningData));
      }, 2000);
    }
  }, [addEvidence]);

  return (
    <React.Fragment>
      <ThemeProvider theme={theme}>
        <Popper className="popperStyle" open={isOpen} transition>
          {({ TransitionProps }) => (
            <ClickAwayListener
              onClickAway={() => {
                handleClose(isEdited);
              }}
            >
              <Fade {...TransitionProps} timeout={350}>
                <Paper
                  sx={{
                    p: 2,
                    width: "1200px",
                    height: "90vh",
                    overflowY: "auto",
                    margin: "auto",
                    mt: "3vh",
                  }}
                  onClick={() => handleClickInsidePopper}
                >
                  <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between'}}>
                    <Box className={"detailsWrapper"} sx={{ mt: 0, width: '80%' }}>
                      <Typography className="fs13 fw700">
                        {genUID(detail?.uid) + " " + detail?.name}
                      </Typography>
                      <Typography className="fs13">
                        {detail?.description}
                      </Typography>
                    </Box>
                    <Navigators 
                    navigatorIds={standardIds} 
                    navigatorData={standards} 
                    manageStateChange={(tempData:any) => {dispatch(setSelectedSaStandard(tempData))}} />
                  </Box>
                  <Box className={"standardDetailsContainer"}>
                    <Box className={"detailsWrapper"}>
                      <Typography className="standardsHeading uppercase">
                        Actions
                      </Typography>
                      <Button
                        className={!isAdmin ? "smallButton" : "displayNone"}
                        sx={{ float: "right" }}
                        disableElevation
                        onClick={() => {
                          manageAddAction();
                        }}
                        variant="contained"
                        size="small"
                        startIcon={
                          <FontAwesomeIcon className="fs13" icon={faPlus} />
                        }
                        disabled={addAction}
                      >
                        {"Add Action"}
                      </Button>
                      <Box sx={{ mt: 6 }}>
                        <ActionsTable
                          data={actions}
                          head={tableHead}
                          currentStandard={detail}
                          isAction={false}
                          addAction={addAction}
                          isLoading={isLoadingActions}
                          isAddLoading={isAddAcionLoad}
                          bg={"#FAFAFA"}
                          handleClick={handleAddActionClick}
                          manageCRUD={manageCRUDMethod}
                          module={t("EVALUATION")}
                        />
                      </Box>
                    </Box>
                    <Box className={"detailsWrapper"}>
                      <Typography className="standardsHeading uppercase">
                        Evidence
                      </Typography>
                      <EvidencePopup
                        isOpen={isOpenLibModal}
                        manageFileSelect={(d: any) => {
                          linkLibraryFile(d);
                        }}
                        manageClickAway={() => {
                          setIsOpenLibModal(false);
                        }}
                      />
                      {!isAdmin && (
                        <>
                          <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                          />
                          <Box sx={{ float: "right" }}>
                            <SplitButton
                              options={[
                                "Add Evidence",
                                "Add Evidence From Library",
                              ]}
                              handleClick={(e: any) => {
                                manageEvidenceClick(e);
                              }}
                            />
                          </Box>
                          {/* <Button className='smallButton' sx={{ float: 'right' }} disableElevation 
                                            onClick={() => {fileInputRef.current.click(); setAddEvidence(true);}} variant='contained' size='small' startIcon={<FontAwesomeIcon icon={faPlus} />} disabled={addEvidence}>
                                                {'Add Evidence'}
                                            </Button> */}
                          {/* <Button className='smallButton mr10' sx={{ float: 'right' }} 
                                            disableElevation 
                                            onClick={() => setAddEvidence(true)} 
                                            variant='contained' size='small' 
                                            startIcon={<FontAwesomeIcon icon={faPlus} />} disabled={addEvidence}>
                                                {'Add Evidence From Library'}
                                            </Button> */}
                        </>
                      )}
                      <Box sx={{ mt: 6 }}>
                        <EvidencesTable
                          data={evidences}
                          isLoading={isLoadingEvidences}
                          bg={"#FAFAFA"}
                        />
                      </Box>
                    </Box>
                    <Box className={"detailsWrapper"}>
                      <Typography className="standardsHeading uppercase">
                        {t("SELF_ASSESSMENT")}
                      </Typography>
                      <Box className={"sdCommentsWrapper"}>
                        <JoyCssVarsProvider>
                          <Textarea
                            sx={{ borderRadius: "6px", mt: 0, width: "80%" }}
                            onChange={(e: any) => {
                              dispatch(
                                setSaComments({
                                  ...selfAssessmentComment,
                                  comment: e.target.value,
                                })
                              );
                              setIsEdited(true);
                            }}
                            placeholder="Add comment"
                            minRows={4}
                            maxRows={4}
                            value={selfAssessmentComment?.comment}
                          />
                        </JoyCssVarsProvider>
                        <Box className={"SDuserDetailsWrapper"}>
                          {selfAssessmentComment?.firstName != null &&
                            selfAssessmentComment?.firstName != "" && (
                              <>
                                <AvatarAndName
                                  avatarName={
                                    selfAssessmentComment?.firstName
                                      ? `${selfAssessmentComment.firstName} ${selfAssessmentComment.lastName}`
                                      : "Undefined"
                                  }
                                  avatarImage={
                                    selfAssessmentComment.avatarPath
                                      ? `${baseUrl}/Content${selfAssessmentComment.avatarPath}`
                                      : ""
                                  }
                                />
                                <Typography
                                  className="fs12"
                                  sx={{ ml: "32px", mb: "10px" }}
                                >
                                  {formatDateTime(
                                    selfAssessmentComment.updatedDate
                                  )}
                                </Typography>
                              </>
                            )}
                        </Box>
                      </Box>
                    </Box>
                    <Box className={"detailsWrapper mt20"}>
                      <Box className={"mb10"}>
                        <SwitchButton
                          label={t("IS_READY") + ": "}
                          isOn={standardStatuses?.isReady}
                          inlineStyle={{
                            color: colors.black.dark,
                            fontWeight: 700,
                          }}
                          handleOnClick={() => {
                            const tempStatusData = {
                              ...standardStatuses,
                              isReady: !standardStatuses?.isReady,
                              standardId: detail?.id,
                              clubId: currentClub?.id,
                            };
                            dispatch(setStandardStatuses(tempStatusData));
                            saveStandardIsComplete(tempStatusData);
                          }}
                        />
                      </Box>
                      <SwitchButton
                        label={t("IS_COMPLETE") + ": "}
                        isOn={standardStatuses?.isComplete}
                        inlineStyle={{
                          color: colors.black.dark,
                          fontWeight: 700,
                        }}
                        handleOnClick={() => {
                          const tempStatusData = {
                            ...standardStatuses,
                            isComplete: !standardStatuses?.isComplete,
                            standardId: detail?.id,
                            clubId: currentClub?.id,
                          };
                          dispatch(setStandardStatuses(tempStatusData));
                          saveStandardIsComplete(tempStatusData);
                        }}
                        disabled={isClubMaker}
                      />
                    </Box>
                  </Box>
                </Paper>
              </Fade>
            </ClickAwayListener>
          )}
        </Popper>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default SAStandardsDetail;
